import templateUrl from './listview-filters.tpl.html';

import '../../filter-field/filter-field'

angular
    .module('festzelt-os.components')
    .component('listviewFilters', {
        bindings: {
            store: '=',
        },
        controller() {
            this.isEmpty = (obj) => {
                let empty = true;
                for (let key in obj) {
                    if (obj.hasOwnProperty(key) && obj[key] && obj[key].length)
                        empty = false;
                }
                return empty;
            }

            this.showFilterTag = (col) => {
                return col.filterable
                    && col.type
                    && ((typeof (this.store.state.filters[col.key]) === 'object' && this.store.state.filters[col.key] !== null && !this.isEmpty(this.store.state.filters[col.key]))
                        || (this.store.state.filters[col.key] && this.store.state.filters[col.key].length)
                        || (col.type === 'boolean' && (this.store.state.filters[col.key] === true || this.store.state.filters[col.key] === false))
                    );
            }

            this.displayFilter = (val, col) => {
                if (!val) {
                    return val;
                }

                switch (col.type) {
                    case 'date':
                        return this.transformDate(val);
                        break;
                    case 'datetime':
                        return this.transformDateTime(val);
                        break;
                }
                if (_.isArray(val)) {
                    return val.join(', ');
                }

                if (val.min || val.max) {
                    let date = '';
                    if (val.min) {
                        date = date.concat(' after: ', moment());
                    }

                    if (val.max) {
                        date = date.concat(' before: ', val.max);
                    }
                    return date.trim();
                }

                if (_.isBoolean(val)) {
                    return val ? 'Yes' : 'No';
                }
                return val;
            }

            this.transformDate = (val) => {
                return this.transformDateStringFilterWithFormat(val, 'DD.MM.YYYY');
            }

            this.transformDateTime = (val) => {
                return this.transformDateStringFilterWithFormat(val, 'DD.MM.YYYY HH:mm');
            }

            this.transformDateStringFilterWithFormat = (val, format) => {
                let out = '';

                if (val.min) {
                    if (Object.keys(val).length < 2) {
                        out += 'After: ';
                    }
                    out += moment(val.min).format(format);
                }

                if (val.max) {
                    if (out !== '') {
                        out += ' - ';
                    } else {
                        out += 'Before: ';
                    }
                    out += moment(val.max).format(format);
                }

                return out;
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/filters/listview-filters.js